import { Dispatcher, Log, toProxy } from "@fanfanlo";
import { IMatrixMessage } from "../message/types";
import { IBooleanState, IMatrixRoomInfo, IRoomMember, IRoomSettingsState } from "./types";
import { MeetingStateMap } from "../../element-call/meetingState.types";

const fileLogger = new Log(false, 'im.client.room.data')
fileLogger.childrenPaused = true;
fileLogger.pause = true;

// 存储已加入房间的ID
const joinedRoomIds = new Set<string>();

// 初始化数据
const joinedRooms = toProxy<IMatrixRoomInfo[]>([]);
const joinedRoomsMap = toProxy<Record<string, IMatrixRoomInfo>>({});
const messages = toProxy<Record<string, string[]>>({});
const messagesMap = toProxy<Record<string, IMatrixMessage>>({});
const roomMembers = toProxy<Record<string, Array<IRoomMember>>>({});
const isFetchingMembers = toProxy<IBooleanState>({ value: false });
const roomSettings = toProxy<IRoomSettingsState>({
    settings: {},
    isLoading: {}
});
const powerLevels = toProxy<Record<string, any>>({});
const lastMessages = toProxy<Record<string, IMatrixMessage | null>>({});
const meetingStateMap = toProxy<MeetingStateMap>({}); 
const dispatcher = new Dispatcher();
// 房间数据对象
export const roomData = {
    joinedRooms,
    joinedRoomsMap,
    messages,
    messagesMap,
    roomMembers,
    isFetchingMembers,
    joinedRoomIds,
    roomSettings,
    powerLevels,
    dispatcher,
    lastMessages,
    meetingStateMap
};
